var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.646 4.575a1.178 1.178 0 0 0 1.666 1.666l1.964-1.964a3.144 3.144 0 1 1 4.447 4.447l-3.928 3.928a3.145 3.145 0 0 1-4.447 0 1.179 1.179 0 0 0-1.666 1.666 5.5 5.5 0 0 0 7.779 0l3.928-3.929a5.5 5.5 0 1 0-7.778-7.778l-1.965 1.964Zm-7.37 15.148a3.142 3.142 0 0 1 0-4.447l3.93-3.928a3.14 3.14 0 0 1 4.446 0 1.179 1.179 0 0 0 1.666-1.666 5.5 5.5 0 0 0-7.779 0l-3.928 3.929a5.5 5.5 0 0 0 7.778 7.778l1.965-1.964a1.179 1.179 0 0 0-1.666-1.666l-1.964 1.964a3.142 3.142 0 0 1-4.447 0Z",
    fill: "currentColor"
  })));
};
export default SvgLink;